import styled from "styled-components";
import { Box } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const TextDescWrapper = styled(Box)`
  border-radius: 12px;
  width: auto;
  margin-bottom: 32px;
  ${(props) => props.styles || ""}
`;

export const DescriptionText = styled(Text)`
  color: var(--Text-Primary-grey600, #121212);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  ${(props) => props.styles || ""}
`;

export const ImageBoxContainer = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  border-radius: 20px;
  background: #f5f5f5;
  margin-right: 12px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;
